import type { LayoutConfig } from "../../hooks/useLayoutConfig";

export const dashboardLayoutConfig: LayoutConfig = {
  topBar: {
    hideRoutes: ["/verify/*", "/invite/*", "/onboarding/*"],
  },
  sidebar: {
    hideRoutes: [
      "/public/*",
      "/verify/*",
      "/invite/*",
      "/onboarding/*",
      "/projects/*",
      "/payment/*",
    ],
    mobileHideRoutes: ["/verify/*", "/invite/*", "/onboarding/*"],
  },
  overlays: {
    hideRoutes: ["/verify/*", "/invite/*", "/onboarding/*"],
  },
  skeleton: {
    hideRoutes: [],
  },
};
